import httpClient from '@/shared/http-auth-data-client';

const getUsers = () => httpClient.get('/users');
const getUserList = () => httpClient.get('/users?$filter=issccuser ne true and IsAnonymous eq false&$expand=userProfile,userphones,memberShip,usersInRoles($expand=Role)');
const getSCCUserList = () => httpClient.get('/users?$filter=issccuser eq true and IsAnonymous eq false&$expand=userProfile,usersInRoles($expand=Role),membership');
const getSCCUserEventLog = (isSccUser) => httpClient.get(`/UserEventLogs?$filter=isSCCUser eq ${isSccUser}`);
const getUserDetails = (userName) => httpClient.get(`/users/${userName}?$expand=userProfile,usersInRoles,membership`);
const getUserProfiles = () => httpClient.get('/UserProfiles');
const getSecurityQuestions = () => httpClient.get('/SecurityQuestions');
const register = (username, email, password, forcePasswordChange, isSCCUser) => httpClient.post('/register', {
  username, email, password, forcePasswordChange, isSCCUser,
});
const resetPassword = (userId, password, forcePasswordChange) => httpClient.put('/reset-password', { userId, password, forcePasswordChange });
const usersSecurityQuestions = (data) => httpClient.post('/usersSecurityQuestions', data);
const updateUsersSecurityQuestions = (data) => httpClient.patch('/usersSecurityQuestions', data);
const getUserProfilesById = (userId) => httpClient.get(`/userprofiles/${userId}`);
const userProfiles = (data) => httpClient.post('/UserProfiles', data);
const userPhones = (phoneType, phoneNumber, ext, userId, isDefault) => httpClient.post('/UserPhones', {
  phoneType, phoneNumber, ext, userId, isDefault,
});
const getUserContacts = (userId) => httpClient.get(`/UserPhones/${userId}`);
const updateUserContacts = (data) => httpClient.patch('/UserPhones', data);
const changePassword = (userName, oldPassword, newPassword) => httpClient.put('/Users/ChangePassword', { userName, oldPassword, newPassword });
const getRoles = () => httpClient.get('/roles?$filter=RoleType eq \'Internal\'');
const userInRoles = (data) => httpClient.patch('/usersInRoles', data);
const deactivateUser = (userName) => httpClient.put('/users/deactive', { userName });
const activateUser = (userName) => httpClient.put('/users/active', { userName });
const getUserPasswordLogById = (userId) => httpClient.get(`/PasswordChangLog/${userId}`);
const unlockUser = (userName) => httpClient.put('/users/unlock', { userName });
const getUserNotes = (userId) => httpClient.get(`/usernotes/${userId}`);
const setUserNotes = (data) => httpClient.post('/usernotes', data);
const deleteUserNotes = (id) => httpClient.delete(`/usernotes/${id}`);

export {
  getUsers,
  getUserList,
  getSCCUserList,
  getSCCUserEventLog,
  getUserDetails,
  getUserProfiles,
  getSecurityQuestions,
  register,
  resetPassword,
  usersSecurityQuestions,
  updateUsersSecurityQuestions,
  getUserProfilesById,
  userProfiles,
  userPhones,
  getUserContacts,
  updateUserContacts,
  changePassword,
  getRoles,
  userInRoles,
  deactivateUser,
  activateUser,
  getUserPasswordLogById,
  unlockUser,
  getUserNotes,
  setUserNotes,
  deleteUserNotes,
};
